<template>
  <div class="meals-container">
    <div v-if="showShopDetail && !isBreakfast &&!isCoffee" class="meals-root-view">
      <div class="shop-title-view">
        <div
          v-for="(item, index) in shopArr"
          :key="index"
          :class="{active: selectedShopIndex === index, marginLeft: index !== 0, 'disabled': !allowOrder}"
          @click="changeSelectedShop(index, item)"
          class="shop-title-item">
            {{ item.busi_name }}
        </div>
      </div>
      <div
        :class="{animatedIn: loading, animatedOut: !loading }"
        class="shop-meals-view">
        <MealItem
          v-for="(item, index) in shopDetailArr"
          :key="index"
          :class="{marginleft: index % 5 !== 0}"
          :meal_info="item"
          :select_id="select_id"
          :disabled="!allowOrder"
        />
      </div>
    </div>
    <div v-else-if="isBreakfast &&!isCoffee && showShopDetail" class="breakfast-view">
      <div v-for="(items, index) in shopArr" :key="index" class="breakfast-img">
        <div class="shop-name">{{ items.busi_name }}</div>
        <div class="detail-container">
          <div class="detail-wrapper">
            <div v-for="(item, i) in items.menu_info.menu_data" :key="i" class="detail">
              {{ item.menu_name }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div  v-else-if="isCoffee"><Coffee /></div>
    <div v-else class="no-data-view">
      <img class="no-data-img" src="../../static/img/meals/pic_default_null.png">
      <span class="text-one">暂无数据</span>
      <span class="text-two">此刻非点餐时间或者管理员还未排选商家</span>
    </div>
    <MealDetail v-if="$store.state.meals.show_shop_detail"/>
  </div>
</template>

<script>
import MealItem from '@/components/meals/meal_item'
import MealDetail from '@/components/meals/meal_detail'
import Coffee from '@/components/coffee/Coffee'
// 当前排单的状态，1表示可以可以下单，2表示不能下单
const ORDER_STATE = {
  ALLOW: 1,
  NOT_ALLOW: 2
}

export default {
  name: 'Meals',
  components: {
    MealItem,
    MealDetail,
    Coffee
  },
  data () {
    return {
      selectedShopIndex: 0,
      shopArr: [],
      shopDetailArr: [],
      select_id: '',
      showShopDetail: false,
      isBreakfast: false,
      isCoffee:false,//新增咖啡模块
      breakfastArr: [],
      loading: false,
      source: null,
      requesting: false,
      orderState: ORDER_STATE.NOT_ALLOW // 当前排单的状态，1表示可以可以下单，2表示不能下单
    }
  },
  computed: {
    // 是否能够下单
    allowOrder () {
      return this.orderState === ORDER_STATE.ALLOW
    }
  },
  watch: {
    // 监听路由变化
    $route (to, from) {
      // this.requestWorkShops(to.query.type)
       if (to.query.type === "coffee") {
        this.isCoffee = true;
      } else {
        this.isCoffee=false
        this.requestWorkShops(to.query.type);

      }
    }
  },
  mounted () {
    // 组件加载后默认显示午餐列表，默认显示列表中的第一家店铺的商品列表
    this.$nextTick(() => {
      this.requestWorkShops(this.$route.query.type)
    })
  },
  methods: {
    /**
     * 改变商家详情数据
     */
    changeSelectedShop (index, data) {
      // 每次切换点食类型时，清空商家信息
      this.shopDetailArr = []
      // 设置要显示的商家下标
      this.selectedShopIndex = index
      // 动画开始
      this.loading = true
      // 设置全局商家信息
      this.$store.commit('set_busi_id', data)
      setTimeout(() => {
        // 切换商家
        this.shopDetailArr = this.shopArr[index].menu_info.menu_data
        // 动画结束
        this.loading = false
      }, 300)
    },
    /**
     * 请求排单商家数据
     */
    requestWorkShops (path) {
      // 如果上一次请求还在请求中，取消上次请求
      if (this.requesting) {
        this.source.cancel('cancel')
      }
      // 请求开始
      this.requesting = true
      // 每次切换点食类型时，清空商家信息
      this.shopArr = []
      this.shopDetailArr = []
      // 每次切换点食类型时，默认无法下单
      this.orderState = ORDER_STATE.NOT_ALLOW
      // 默认午餐
      let select_type = 2
      // 显示早餐卡片与否
      if (path === 'breakfast') {
        this.isBreakfast = true
      } else {
        this.isBreakfast = false
      }
      // 根据路由参数判断是哪种类型的餐食
      switch (path) {
        case 'breakfast':
          select_type = 1
          break
        case 'lunch':
          select_type = 2
          break
        case 'afternoon_tea':
          select_type = 3
          break
        case 'overtime_meal':
          select_type = 4
          break
        case 'coffee':
          select_type = 5
          break
        case 'try_eating':
          select_type = 8
          break
      }
      // 定义网络请求参数
      let params = {
        cmd: 4,
        floor: +this.$store.state.user_info.position,
        select_type: +select_type
      }
      // 取消请求令牌
      this.source = this.axios.CancelToken.source()
      // 请求数据
      this.axios.post('/api/frontend/select_order', params, { cancelToken: this.source.token })
      .then((res) => {
        // 请求结束
        if(select_type===5){
          this.isCoffee=true
          return false
        }
        this.requesting = false
        switch (res.data.status) {
          case 0:
            // 赋值是否能够下单
            this.orderState = res.data.select_data[0].order_state
            // 展示商品
            this.showShopDetail = true
            // 设置全局排单ID，提交订单时要用到
            this.select_id = res.data.select_data[0].select_id
            // 设置全局商家信息
            this.$store.commit('set_select_id', res.data.select_data[0].select_id)
            // 将菜品数量合并到相应的菜品里
            let tempData = res.data.select_data[0].business_info
            // 合并菜品销量，排序
            tempData.map((items, index) => {
              // 没有标签的第一个菜品下标
              let labelIndex = 0
              items.menu_info.menu_data.map((item, i) => {
                item.menu_count = res.data.menu_count_data[item.menu_id].count
                if (item.tag_name.length !== 0) {
                  labelIndex = i + 1
                }
              })
              let arr1 = items.menu_info.menu_data.slice(0, labelIndex).sort(function(a, b) { return b.menu_count - a.menu_count })
              // 不带标签的数据排序
              let arr2 = items.menu_info.menu_data.slice(labelIndex, items.menu_info.menu_data.length).sort(function(a, b) { return b.menu_count - a.menu_count })
              items.menu_info.menu_data = [...arr1, ...arr2]
            })
            // 将整合数量以及排序后的数据给shopArr
            this.shopArr = tempData
            this.changeSelectedShop(0, this.shopArr[0])
            break
          case 1:
            // 隐藏商品
            this.showShopDetail = false
            this.$store.commit('show_alert', '还未排单呦！')
            break
        }
      })
      .catch((err) => {
        // 请求结束
        this.requesting = false
        // 如果非手动取消请求失败，请求失败后跳转到登录页面
        if (err.message != 'cancel') {
          // 隐藏商品
          this.showShopDetail = false
          // 跳转到登陆界面
          this.$router.push('/p/login')
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.meals-container {
  width: 100%;
  height: calc(~"100% - 70px");
  // display: flex;
  // justify-content: center;
  overflow: auto;
  .meals-root-view {
    width: 1200px;
    height: 100%;
    margin:0 auto;
    border: 1px solid transparent;
    .shop-title-view {
      margin-top: 30px;
      width: 100%;
      height: 60px;
      display: flex;
      flex-direction: row;
      .shop-title-item {
        width: 200px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        font-size: 20px;
        color: #dbb193;
        &.disabled {
          // background-color: #D8D8D8;
          &:hover, &.active {
            background-color: #727272;
            box-shadow: 0px 10px 20px 0px rgba(114, 114, 114, 0.2);
          }
        }
      }
      .shop-title-item:hover, .active {
        background-color: #ff7814;
        box-shadow: 0px 10px 20px 0px rgba(232, 152, 63, 0.2);
        border-radius: 4px;
        color: #ffffff;
      }
      .marginLeft {
        margin-left: 20px;
      }
    }
    .shop-meals-view {
      width: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      margin-bottom: 20px;
      .marginleft {
        margin-left: 20px;
      }
    }
    .animatedIn {
      opacity: 0;
      transition: all .3s ease;
    }
    .animatedOut {
      opacity: 1;
      transition: all .3s ease;
    }
  }
  .breakfast-view {
    width: 1200px;
    display: flex;
    flex-direction: row;
    margin: 0 auto;
    .breakfast-img {
      width: 258px;
      height: 334px;
      background-image: url('../../static/img/meals/bg_breakfast.png');
      .shop-name {
        width: 100%;
        height: 126px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 20px;
        color: #ffffff;
      }
      .detail-container {
        height: 184px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .detail-wrapper {
          width: 200px;
          overflow: auto;
          .detail {
            width: 200px;
            text-align: center;
            margin-top: 16px;
            font-size: 18px;
            color: #333333;
          }
        }
      }
    }
  }
  .no-data-view {
    width: 400px;
    height: 300px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin:0 auto;
    margin-top: 90px;
    .no-data-img {
      width: 190px;
      height: 146px;
    }
    .text-one {
      font-size: 24px;
      color: #333333;
      margin-top: 20px;
    }
    .text-two {
      font-size: 16px;
      color: #999999;
      margin-top: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/meals.vue